import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Fingerprint2 from 'fingerprintjs2sync';
import { isSSR } from '../scripts/utils.js';

export const getQueryString = (name, history) =>  {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = history?.location?.search?.substr(1).match(reg);
  if (r != null) {
      return unescape(r[2]);
  }
  return undefined;  
}

function getDeviceType() {
  if (isSSR) return -1;
  if(typeof navigator === 'undefined')return -1;
  const u = navigator.userAgent.toLowerCase();
  // 判断安卓设备（包含Android或Adr标识）
  const isAndroid = u.indexOf('android')  > -1 || u.indexOf('adr')  > -1;
  // 判断iOS设备（包含iPhone/iPad/iPod）
  const isIOS = (u.indexOf('iphone')  > -1 || u.indexOf('ipad')  > -1 || u.indexOf('ipod')  > -1) ;
  
  if (isAndroid) return 0;
  if (isIOS) return 1;
  return 2; // 其他设备 后台、Windows、MacOS、等属于PC
}

export default function useDeviceInfo() {
  const history = useHistory()
  
  // 确保服务端和客户端使用相同的初始值
  const [deviceId, setDeviceId] = useState(undefined);
  const [deviceType, setDeviceType] = useState(undefined);
  const [bd_vid, setBd_vid] = useState(undefined);
  const [ext_info, setExt_info] = useState(undefined);

  useEffect(() => {
    // 获取查询参数
    const tempBd_vid = getQueryString('bd_vid', history);
    const tempExt_info = getQueryString('ext_info', history);
    setBd_vid(tempBd_vid);
    setExt_info(tempExt_info);
    
    // 获取设备信息
    if (typeof navigator !== 'undefined') {
      const tempDeviceType = getDeviceType();
      setDeviceType(tempDeviceType);
      const tempDeviceId = (new Fingerprint2()).getSync().fprint;
      setDeviceId(tempDeviceId);
    }
  }, [history]);

  return { bd_vid, ext_info, deviceType, deviceId };
}
